export const ALPHABETICAL_SORT = "alphabetical";
const DEFAULT_SORT_DIRECTION = "asc";
export const defaultSortDirectionForMode = (mode, sliceSortDefault) => {
  if ((sliceSortDefault == null ? void 0 : sliceSortDefault.mode) === mode) {
    return sliceSortDefault.direction;
  }
  return DEFAULT_SORT_DIRECTION;
};
